import React from "react";
import LegalLayout from "../../components/LegalLayout";

const OnBilgilendirme = () => {
  return (
    <LegalLayout title="Ön Bilgilendirme Formu">

      <h2>1. Satıcı Bilgileri</h2>

      <ul>
        <li><strong>Şirket Ünvanı:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.</li>
        <li><strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9 Güngören / İstanbul</li>
        <li><strong>Telefon:</strong> +90 537 210 14 52</li>
        <li><strong>E-posta:</strong> goomoreinternational@gmail.com</li>
        <li><strong>Vergi Dairesi:</strong> Esenler Vergi Dairesi</li>
        <li><strong>Vergi No:</strong> 6430860629</li>
      </ul>

      <br />

      <h2>2. Ürün Bilgileri</h2>

      <p>
        Satın alınan ürün veya ürünlere ait isim, miktar, birim fiyat,
        toplam satış bedeli, varsa kargo ücreti ve genel ödeme tutarı
        sipariş ekranında gösterilmekte olup, sipariş onayı ile birlikte
        kesinleşmektedir.
      </p>

      <br />

      <h2>3. Ödeme Bilgileri</h2>

      <p>
        Ödeme işlemleri SSL korumalı güvenli ödeme altyapısı üzerinden
        gerçekleştirilmektedir.
      </p>

      <br />

      <h2>4. Teslimat Bilgileri</h2>

      <p>
        Siparişler ödeme onayının alınmasının ardından hazırlanmaya başlanır.
      </p>

      <p>
        Teslimatlar anlaşmalı kargo firmaları aracılığıyla gerçekleştirilmektedir.
        Normal şartlarda teslimat süresi 1-5 iş günü olup; resmi tatiller,
        yoğunluk veya mücbir sebepler nedeniyle değişiklik gösterebilir.
      </p>

      <br />

      <h2>5. Kargo Bilgileri</h2>

      <p>
        Ürünler, sipariş sırasında belirtilen teslimat adresine gönderilmektedir.
      </p>

      <p>
        Varsa kargo ücreti sipariş ekranında ayrıca gösterilmekte ve toplam
        ödeme tutarına dahil edilmektedir.
      </p>

      <br />

      <h2>6. Cayma Hakkı</h2>

      <p>
        Tüketici, ürünü teslim aldığı tarihten itibaren 14 (ondört) gün
        içerisinde herhangi bir gerekçe göstermeksizin cayma hakkını
        kullanabilir.
      </p>

      <p>
        Cayma hakkının kullanımına ilişkin detaylar "İptal ve İade Politikası"
        ile "Mesafeli Satış Sözleşmesi" sayfalarında yer almaktadır.
      </p>

      <br />

      <h2>7. İade ve Geri Ödeme</h2>

      <p>
        İade talebinin mevzuata uygun bulunması halinde ürün bedeli,
        ödeme yapılan yöntem kullanılarak yasal süre içerisinde tüketiciye
        iade edilir.
      </p>

      <br />

      <h2>8. Uyuşmazlıkların Çözümü</h2>

      <p>
        İşbu Ön Bilgilendirme Formu kapsamında doğabilecek uyuşmazlıklarda,
        Ticaret Bakanlığı tarafından her yıl ilan edilen parasal sınırlar
        dahilinde Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.
      </p>

      <br />

      <h2>9. Bilgilendirme ve Onay</h2>

      <p>
        ALICI, siparişini tamamlamadan önce bu Ön Bilgilendirme Formu'nu
        elektronik ortamda okuyup anladığını ve siparişini bu bilgiler
        doğrultusunda oluşturduğunu kabul ve beyan eder.
      </p>

     <h2>10. Resmi satış sitesi</h2>

      <p>
        Ürünlerin resmi satış kanalı goomorebackoffice.com sitesi üzerinden gerçekleşmektedir.
      </p>

    </LegalLayout>
  );
};

export default OnBilgilendirme;